import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import './AdminDashboard.css'; // Import the CSS file for the Admin Dashboard page
import axiosInstance from './axiosInstance'; // Import the axios instance

const fetchData = async (url, setter, navigate) => {
  try {
    const response = await axiosInstance.get(url);
    console.log(`Data from ${url}:`, response.data); // Log the response data
    if (url.includes('users')) {
      setter(response.data.totalUsers);
    } else if (url.includes('tutors')) {
      setter(response.data.totalTutors);
    } else if (url.includes('blogs')) {
      setter(response.data.totalBlogs);
    } else if (url.includes('subscribers')) {
      setter(response.data.totalSubscribers);
    }
  } catch (error) {
    console.error(`Error fetching data from ${url}:`, error);
    if (error.response && (error.response.status === 401 || error.response.status === 400)) {
      navigate('/admin/login');
    }
  }
};

const AdminDashboard = ({ showNames }) => {
  const navigate = useNavigate();
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalTutors, setTotalTutors] = useState(0);
  const [totalBlogs, setTotalBlogs] = useState(0);
  const [totalSubscribers, setTotalSubscribers] = useState(0);

  useEffect(() => {
    const token = Cookies.get('token');
    console.log('Token from cookie:', token); // Log the token

    if (!token) {
      navigate('/admin/login');
      return;
    }

    fetchData('https://simplyigbo-backend.onrender.com/api/admin/users/total', setTotalUsers, navigate);
    fetchData('https://simplyigbo-backend.onrender.com/api/admin/tutors/total', setTotalTutors, navigate);
    fetchData('https://simplyigbo-backend.onrender.com/api/admin/blogs/total', setTotalBlogs, navigate);
    fetchData('https://simplyigbo-backend.onrender.com/api/admin/subscribers/total', setTotalSubscribers, navigate);
  }, [navigate]);

  console.log('Rendering AdminDashboard with state:', { totalUsers, totalTutors, totalBlogs, totalSubscribers });

  const [adminFirstName, setAdminFirstName] = useState('Admin');
  useEffect(() => {
    const fetchAdminFirstName = async () => {
        try {
            const response = await axiosInstance.get('/admin/first-name');
            setAdminFirstName(response.data.first_name);
        } catch (err) {
            console.error('Failed to fetch admin first name', err);
        }
    };

    fetchAdminFirstName();
}, []);

  return (
    <div className={`admin-dashboard-container ${showNames ? 'show-names' : ''}`}>
      <div className="mini-header">
        <h1 className="mini-header-title">Admin Dashboard</h1>
        <div className="mini-header-right">
          <span className="admin-name">{adminFirstName}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
            <path fill="currentColor" strokeWidth="2" strokeLinecap="round" d="M23 9A7 7 0 1 1 9 9a7 7 0 0 1 14 0m-2 0a5 5 0 1 0-10 0a5 5 0 0 0 10 0M7.5 18A3.5 3.5 0 0 0 4 21.5v.5c0 2.393 1.523 4.417 3.685 5.793C9.859 29.177 12.802 30 16 30s6.14-.823 8.315-2.207C26.477 26.417 28 24.393 28 22v-.5a3.5 3.5 0 0 0-3.5-3.5zM6 21.5A1.5 1.5 0 0 1 7.5 20h17a1.5 1.5 0 0 1 1.5 1.5v.5c0 1.473-.94 2.949-2.759 4.106C21.434 27.256 18.877 28 16 28s-5.434-.744-7.241-1.894C6.939 24.95 6 23.472 6 22z" />
          </svg>
        </div>
      </div>
      <div className="dashboard-container">
        <div className="dashboard-content">
          <div className="dashboard-grid">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Total Users</h3>
                <p className="card-number">{totalUsers}</p>
              </div>
              <Link to="/admin/users" className="card-button">View</Link>
            </div>
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Total Tutors</h3>
                <p className="card-number">{totalTutors}</p>
              </div>
              <Link to="/admin/tutors" className="card-button">View</Link>
            </div>
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Total Blogs</h3>
                <p className="card-number">{totalBlogs}</p>
              </div>
              <Link to="/admin/blog" className="card-button">View</Link>
            </div>
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Total Subscribers</h3>
                <p className="card-number">{totalSubscribers}</p>
              </div>
              <Link to="/admin/newsletter" className="card-button">View</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;